import React from 'react';
import { Row, Col } from 'react-bootstrap';
import Progress from "../../../components/Progress";

const ProgressContainer = ({presentations, intl}) => {
  console.log("ProgressContainer",presentations);
  return (
    <Row>
      <Col>
        <Progress complete={
          presentations.length ? (
            (presentations.filter(function (p) {
              return p.status !== "no-ppt" || p.ppt.length > 0  ;
            }).length *
              100) /
            presentations.length
          ).toFixed(0)
            : 0
        } title={intl.formatMessage({id: "loaded.files"})}
        number={presentations.length ?
          (presentations.filter(function (p) {
            return p.status !== "no-ppt" || p.ppt.length > 0;
          }).length) : '' } />
      </Col>
      <Col>
        <Progress complete={
          presentations.length ? (
            (presentations.filter(function (p) {
              return (
                p.status === "video-recorded" ||
                p.status === "published"
              )
            }).length *
              100) /
            presentations.length
          ).toFixed(0)
            : 0
        } title={intl.formatMessage({id: "recorded.videos"})}
        number={presentations.length ?
          (presentations.filter(function (p) {
            return (
              p.status === "video-recorded" ||
              p.status === "published"
            )
          }).length) : '' }
           />
      </Col>
      <Col>
        <Progress complete={
          presentations.length ? (
            (presentations.filter(function (p) {
              return p.status === "published";
            }).length *
              100) /
            presentations.length
          ).toFixed(0)
            : 0
        } title={intl.formatMessage({id: "loded.videos"})}
        number={presentations.length ?
          (presentations.filter(function (p) {
            return p.status === "published";
          }).length) : '' } />
      </Col>
    </Row>
  )
}

export default ProgressContainer;